import { render, staticRenderFns } from "./CrudEdit.vue?vue&type=template&id=5e458173&scoped=true"
import script from "./CrudEdit.vue?vue&type=script&lang=js"
export * from "./CrudEdit.vue?vue&type=script&lang=js"
import style0 from "./CrudEdit.vue?vue&type=style&index=0&id=5e458173&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e458173",
  null
  
)

export default component.exports